




























































import Vue from "vue";
import { authentication } from "@/stores";
import { Tenant, TenantUser } from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef } from "@/stores";
import { shopBase } from "@/mixins";
import dayjs from "dayjs";

const db = firebaseProject.firestore();

const tenant = new Collection(
  db.collection("tenant") as firestore.CollectionReference<Tenant>
);

export default shopBase.extend(Vue).extend({
  name: "TenantList",
  mixins: [],
  async created() {
    await this.refreshTenantUsers();
    this.loaded = true;
  },
  data(): {
    authentication: object;
    transitionName: string;
    _tenantUsers: TenantUser[];
    loaded: boolean;
    parPage: number;
    currentPage: number;
  } {
    return {
      authentication,
      transitionName: "",
      _tenantUsers: [],
      loaded: false,
      parPage: 10,
      currentPage: 1
    };
  },
  computed: {
    tenants(): List<Tenant> {
      return tenant.query({
        filter: {
          shopId: { $eq: this.shopId }
        },
        orderBy: {
          field: "createTime",
          order: "desc"
        }
      });
    },
    listItem(): DocDataRef<Tenant>[] | [] {
      const current = this.currentPage * this.parPage;
      const start = current - this.parPage;
      return this.tenants?.items
        ? this.tenants.items
            .filter(
              item =>
                (typeof item?.data?.notAeonShop === "string" &&
                  item?.data?.notAeonShop !== "1") ||
                !item?.data?.notAeonShop
            )
            .slice(start, current)
        : [];
    },
    getPageCount(): number {
      return this.tenants?.items
        ? Math.ceil(
            this.tenants.items.filter(
              item =>
                (typeof item?.data?.notAeonShop === "string" &&
                  item?.data?.notAeonShop !== "1") ||
                !item?.data?.notAeonShop
            ).length / this.parPage
          )
        : 0;
    },
    total(): number | undefined {
      return this.tenants?.items
        ? this.tenants.items.filter(
            item =>
              (typeof item?.data?.notAeonShop === "string" &&
                item?.data?.notAeonShop !== "1") ||
              !item?.data?.notAeonShop
          ).length
        : 0;
    },
    pageMax(): number {
      const count = this.currentPage * this.parPage;
      const total = this.total || 0;
      return total < count ? total : count;
    },
    tenantUsers(): TenantUser[] | null {
      return this._tenantUsers;
    }
  },
  methods: {
    clickPaginate(pageNum: number) {
      this.currentPage = Number(pageNum);
    },
    getTenantUser(tenantId: string): TenantUser | undefined {
      const user = this.tenantUsers?.find(user => {
        return user.tenantId == tenantId;
      });
      return user;
    },
    tenantUserName(tenantId: string): string | undefined {
      return this.getTenantUser(tenantId)?.userName;
    },
    tenantUserEmail(tenantId: string): string | undefined {
      return this.getTenantUser(tenantId)?.email;
    },
    tenantUserPhonenumber(tenantId: string): string | undefined {
      return this.getTenantUser(tenantId)?.phoneNumber;
    },
    async refreshTenantUsers() {
      const tenantUsers = new Collection(
        db.collection("tenantUser") as firestore.CollectionReference<TenantUser>
      ).query({
        filter: {
          shopId: { $eq: this.shopId }
        },
        orderBy: {
          field: "createTime",
          order: "desc"
        }
      });
      this._tenantUsers = [];
      const snapshot = await tenantUsers.ref.get();
      snapshot.docs.forEach(item => {
        const d = item.data();
        if (d) {
          this._tenantUsers.push(d);
        }
      });
    }
  }
});
